import { ACTOR_ACCENT_BG_CLASSES } from '@cartwhl/3d/player';

/**
 * Accent colors for multi-body batch preview (download row dots, 3D head tags, etc.).
 * Sourced from the shared @cartwhl/3d constant so dots and head tags always match.
 * Order is stable: body index 0 → first entry, etc.
 */
export { ACTOR_ACCENT_BG_CLASSES as BATCH_BODY_ACCENT_BG_CLASSES };

export function batchBodyAccentBgClass(bodyIndex0: number): string {
  return ACTOR_ACCENT_BG_CLASSES[bodyIndex0 % ACTOR_ACCENT_BG_CLASSES.length]!;
}
